(function(){
  var btn = document.getElementById('nav-toggle-btn');
  var menu = document.getElementById('mobile-menu');
  var closeBtn = document.getElementById('mobile-menu-close');
  if(!btn || !menu){ return; }

  function openMenu(){
    menu.classList.add('open');
    btn.setAttribute('aria-expanded', 'true');
    if(closeBtn){ closeBtn.focus(); }
    document.body.style.overflow = 'hidden';
  }
  function closeMenu(){
    menu.classList.remove('open');
    btn.setAttribute('aria-expanded', 'false');
    btn.focus();
    document.body.style.overflow = '';
  }

  btn.addEventListener('click', function(){
    if(menu.classList.contains('open')){ closeMenu(); } else { openMenu(); }
  });
  if(closeBtn){ closeBtn.addEventListener('click', closeMenu); }
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && menu.classList.contains('open')){ closeMenu(); }
  });
  menu.querySelectorAll('a').forEach(function(a){
    a.addEventListener('click', closeMenu);
  });
})();
